import React, { useState } from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { Input as MobileInput, Button as MobileButton } from 'antd-mobile';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useAdmin } from '../../context/AdminContext';
import { useIsMobile } from '../../hooks/useMediaQuery';
import styles from './AdminLogin.module.css';

const { Title, Text } = Typography;

export default function AdminLogin() {
  const isMobile = useIsMobile();
  const { verifyLogin } = useAdmin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (values) => {
    setError('');
    const ok = verifyLogin(values?.username ?? username, values?.password ?? password);
    if (!ok) setError('账号或口令错误，请重试');
  };

  const displayError = error;

  if (isMobile) {
    return (
      <section className={`card ${styles.loginPage}`}>
        <div className={styles.header}>
          <Title level={4} className={styles.title}>管理后台登录</Title>
          <Text className={styles.desc}>在途 · 企业工装福利申领数据管理</Text>
        </div>

        <div className={styles.formPanel}>
          <div className={styles.mobileForm}>
            <div>
              <span className={styles.mobileLabel}><UserOutlined /> 管理员账号</span>
              <MobileInput
                placeholder="请输入账号"
                value={username}
                onChange={setUsername}
                clearable
              />
            </div>
            <div>
              <span className={styles.mobileLabel}><LockOutlined /> 管理口令</span>
              <MobileInput
                type="password"
                placeholder="请输入口令"
                value={password}
                onChange={setPassword}
                clearable
              />
            </div>
            {displayError && <Text type="danger" className={styles.error}>{displayError}</Text>}
            <MobileButton
              block
              color="primary"
              size="large"
              className={styles.submitBtn}
              onClick={() => handleSubmit({ username, password })}
              disabled={!username.trim() || !password}
            >
              登录管理后台
            </MobileButton>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`card ${styles.loginPage}`}>
      <div className={styles.header}>
        <Title level={3} className={styles.title}>管理后台登录</Title>
        <Text className={styles.desc}>在途 · 企业工装福利申领数据管理</Text>
      </div>

      <div className={styles.formPanel}>
        <Form layout="vertical" onFinish={handleSubmit} requiredMark={false}>
          <Form.Item
            label="管理员账号"
            name="username"
            rules={[{ required: true, message: '请输入管理员账号' }]}
          >
            <Input
              size="large"
              prefix={<UserOutlined />}
              placeholder="请输入账号"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            label="管理口令"
            name="password"
            rules={[{ required: true, message: '请输入管理口令' }]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined />}
              placeholder="请输入口令"
              autoComplete="current-password"
            />
          </Form.Item>

          {displayError && (
            <Text type="danger" className={styles.error}>{displayError}</Text>
          )}

          <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
            <Button type="primary" htmlType="submit" size="large" block className={styles.submitBtn}>
              登录管理后台
            </Button>
          </Form.Item>
        </Form>
      </div>
    </section>
  );
}
